<script lang="ts" setup>
import {onMounted} from 'vue';
import {getRedirectUrlApi} from '@/api/labelApis';
import {useRoute, useRouter} from 'vue-router';
const route = useRoute()
const router = useRouter()
onMounted(async () => {
  const { url } = await getRedirectUrlApi(route.path)
  if (url) {
    await router.replace(url)
  } else {
    await router.replace({name: 'HomeView'})
  }
})
</script>

<template>
  <div></div>
</template>

